"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dom_1 = __importDefault(require("react-dom"));
var index_1 = __importDefault(require("./components/index"));
var courseId = document
    .getElementById('opo-checkout')
    .getAttribute('data-course');
var coursePrice = document
    .getElementById('opo-checkout')
    .getAttribute('data-price');
var coursePriceOriginal = document
    .getElementById('opo-checkout')
    .getAttribute('data-price-original');
var courseName = document
    .getElementById('opo-checkout')
    .getAttribute('data-course-name');
var freeSample = document
    .getElementById('opo-checkout')
    .getAttribute('data-sample');
react_dom_1.default.render((0, jsx_runtime_1.jsx)(index_1.default, { courseId: courseId, courseName: courseName, price: coursePrice, priceOriginal: coursePriceOriginal, freeSample: freeSample }), document.getElementById('opo-checkout'));
//# sourceMappingURL=checkout.js.map